export const amplitudeEvents = {
  DASHBOARD_LOADED: 'dashboard_loaded',
  DASHBOARD_DATA_COMPLETED: 'dashboard_data_completed',
  FILTER_APPLIED: 'filters_applied',
  SECTION_CLICKED: 'dashboard_clicked',
  SUPPORT_CLICKED: 'dashboard_support_clicked',
  USER_LOGOUT: 'user_logout',
  USER_LOGGED_IN: 'user_logged_in',
  DOWNLOAD_IMAGE: 'download_image',
  DOWNLOAD_CSV: 'download_csv',
  DOWNLOAD_CSV_DRILLDOWN: 'download_csv_drilldown',
  CONVERSATION_OPENED: 'conversation_opened',
  CONVERSATION_STARTED: 'conversation_started',
  CONVERSATION_PROMPT_SENT: 'conversation_prompt_sent',
}
